import { useQuery } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";

export const getAttemptAnswers = async (enrollmentId, attemptId) => {
  const res = await axios.apiCadernoVirtual(
    "/diary-service/diary/listSurveyAttemptsAnswer",
    { params: { enrollmentId, attemptId } }
  );
  return res.object;
};

export const useStudentAttemptAnswers = ({
  config,
  enrollmentId,
  attemptId,
} = {}) => {
  return useQuery({
    ...config,
    queryKey: ["attemptAnswers", { enrollmentId, attemptId }],
    queryFn: () => getAttemptAnswers(enrollmentId, attemptId),
  });
};
